__turbopack_context__.v({
  "code": "CodeEditorContent-module__c0WMZa__code",
  "codeBlock": "CodeEditorContent-module__c0WMZa__codeBlock",
  "container": "CodeEditorContent-module__c0WMZa__container",
  "fileRefs": "CodeEditorContent-module__c0WMZa__fileRefs",
});
